module.exports = __webpack_public_path__ + "img/mail_736506bf.3bf4224e.svg";